import React from 'react'


function About() {
  return (

    <div className='flex flex-col items-center w-full mt-14'>
      <div className="w-full mb-3 bg-pcas-team saturate-50 bg-no-repeat bg-cover bg-center">

      <h4 className='text-3xl md:text-6xl md:py-72 py-24 font-black leading-relaxed backdrop-grayscale backdrop-filter backdrop-brightness-50 text-center text-white p-20'>About Us</h4>
      </div>
      {/* <img className="w-1/2 p-3 ring-4 ring-orange-500 grayscale rounded-md my-5" src="https://firebasestorage.googleapis.com/v0/b/pcas-jobportal.appspot.com/o/IMG-20220325-WA0056.jpg?alt=media&token=b9648923-45d0-4fe8-b5cd-e6a9f74c2031" alt="" />
       */}
      <div className="grid grid-cols-9 gap-4 shadow-2xl rounded-md mt-2">
        <div></div>
        <p className="text-md col-span-4 md:text-lg p-4 font-normal bg-slate-200 rounded-xl text-justify leading-loose">The Poornima College Alumni Society (PCAS) is an organization, composed of PCE & PSBM alumni and alumni groups and student coordinators organized across the world, with a view to preserve and carry forward the fine traditions of Poornima, to strengthen the connection between the alumni at home and abroad and college. Alumni spread across India, and even the world; they play an important role in social development and national rejuvenation.
The great achievements they make have gained a high reputation for their alma mater. To strengthen the cooperation between alumni at home and abroad, as well as alumni and alma mater, and to serve our alumni, the University established the alumni society and has been working productively since then.
We are an engaged alumni society with vibrant communication that actively reaches out, participates fully, and welcomes and shares new ideas and fresh thinking. As alumni society let us stand together in advancing the goal of PCE & PSBM, to be the leading College of Rajasthan, offering recognised education and leadership.
We seek to bring the alumni of Poornima Group together to foster mutual relationships while stimulating & strengthening an old network.
        </p>
        <div className="col-span-3 grid grid-cols-2 bg-slate-200 gap-2 rounded-xl p-4"> 
        <img src="http://pcas.poornima.org/assests/img/gallery/gal11.JPG" className="rounded-md" alt="" />
        <img src="http://pcas.poornima.org/assests/img/gallery/gal11.JPG" className="rounded-md" alt="" />
        <img src="http://pcas.poornima.org/assests/img/gallery/gal11.JPG" className="rounded-md" alt="" />
        <img src="http://pcas.poornima.org/assests/img/gallery/gal11.JPG" className="rounded-md" alt="" />
        <img src="http://pcas.poornima.org/assests/img/gallery/gal11.JPG" className="rounded-md" alt="" />
        </div>
        <div></div>
        
      </div>
    </div> 
  );
}
//
export default About;
